// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineSizeTokenSchema} from "./spacing.zod";

export const mantineTextPropsSchema = z.strictObject({
	fw: z.union([z.string(), z.number()]).optional(),
	size: mantineSizeTokenSchema.optional(),
	c: z.string().optional(),
	fs: z.string().optional(),
});
